import { BuildConfig } from "./BuildConfig";

export const followUpReportBuildConfig: BuildConfig = {
  actionsOrder: ["pick", "transform"],
  pick: {
    topLevelSections: {
      textIds: ["PATIENT COMFORT ASSESSMENT GUIDE"],
    },
  },
} as const;
